import $ from "jquery";
import { BaseVerifyIdentityComponent, VerifyIdentityConfig } from "./BaseVerifyIdentityComponent";
import { requestLoginCode, verifyLoginCode } from "../../requests/post";

/**
 * Component for web application login verification.
 * Handles 2FA code verification for standard web login flow.
 */
export class WebLoginVerifyComponent extends BaseVerifyIdentityComponent {
    public static selector: string = "web-login-verify-component";

    protected getConfig(): Partial<VerifyIdentityConfig> {
        return {
            autoAdvance: true,
            inputMode: "individual",
            onSendCode: (email: string) => requestLoginCode(email),
            onVerifyCode: (email: string, code: string) => verifyLoginCode(email, code),
            onResendCode: (email: string) => requestLoginCode(email)
        };
    }

    protected handleVerifySuccess(response: any): void {
        if (response.redirect_url) {
            window.location.href = response.redirect_url;
        } else {
            // Default redirect to account page
            window.location.href = "/account/";
        }
    }

    protected handleVerifyError(error: any): void {
        let errorMessage = "Invalid code. Please try again.";

        if (error.responseJSON) {
            if (error.responseJSON.code === "expired") {
                errorMessage = "Code expired. Please request a new one.";
            } else if (error.responseJSON.detail) {
                errorMessage = error.responseJSON.detail;
            } else if (error.responseJSON.message) {
                errorMessage = error.responseJSON.message;
            }
        }

        this.showError(errorMessage);
    }

    protected handleBack(): void {
        // Show the login form again
        this.componentElement.parent().hide();
        $("[data-login-form]").show();
    }
}
